var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "product-carousel" },
    [
      _c(
        "swiper",
        { attrs: { options: _vm.swiperOption } },
        [
          _vm._l(_vm.products, function(product) {
            return _c(
              "swiper-slide",
              { key: product.id },
              [_c("ProductTeaser", { attrs: { product: product } })],
              1
            )
          }),
          _vm._v(" "),
          _c("button", {
            staticClass: "swiper-button-prev",
            attrs: {
              slot: "button-prev",
              "aria-label": _vm.$modeoL10n.previous
            },
            slot: "button-prev"
          }),
          _vm._v(" "),
          _c("button", {
            staticClass: "swiper-button-next",
            attrs: { slot: "button-next", "aria-label": _vm.$modeoL10n.next },
            slot: "button-next"
          })
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-20c57416", { render: render, staticRenderFns: staticRenderFns })
  }
}